/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
import React, { useMemo } from "react";
import { getCalendarRows } from "../../../utils/Calendar";
import DatePickerCalendarModule from "./DatePickerCalendar.module.css";

export interface DatePickerCalendarProps {
  shownDate: Date;
  selectedDate: Date;
  currentDate: Date;
  onChange: (date: Date) => void;
}

export const DatePickerCalendar: React.FC<DatePickerCalendarProps> = ({ shownDate, selectedDate, currentDate, onChange }) => {
  const daysOfWeek = ["S", "M", "T", "W", "T", "F", "S"];

  const handleSelectDate = (value: Date) => {
    return () => onChange(value);
  };

  const rows = useMemo(() => getCalendarRows(shownDate, currentDate), [shownDate, currentDate]);

  return (
    <div className={DatePickerCalendarModule.DatePickerCalendarCard}>
      <div className={DatePickerCalendarModule.DatePickerCalendarHeader}>
        {rows[0].map(({ value }, i) => (
          <div key={i} className={DatePickerCalendarModule.DatePickerCalendarCell}>
            {daysOfWeek[value.getDay()]}
          </div>
        ))}
      </div>

      {rows.map((cells, rowIndex) => (
        <div key={rowIndex} className={DatePickerCalendarModule.DatePickerCalendarRow}>
          {cells.map(({ text, value, isActiveMonth, isValidDate }, i) => (
            <div
              key={`${text} - ${i}`}
              className={`${DatePickerCalendarModule.DatePickerCalendarCell} ${
                isValidDate && isActiveMonth
                  ? DatePickerCalendarModule.DatePickerCalendarActiveMonthDayCell
                  : DatePickerCalendarModule.DatePickerCalendarDayCell
              } ${
                isValidDate &&
                isActiveMonth &&
                value.toDateString() === selectedDate.toDateString() &&
                DatePickerCalendarModule.DatePickerCalendarActiveMonthDayCell_selected
              }`}
              onClick={isValidDate && isActiveMonth ? handleSelectDate(value) : () => {}}
            >
              {text}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
